import React, { useContext, useEffect } from "react";
import LayerSettingsContainer from "./LayerSettingsContainer";
import {
    Grid,
    Typography,
    Switch,
    Slider,
    Divider,
    Checkbox,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DataContext } from "../../context/DataContext";
import { IconButton } from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useMap } from "@mapcomponents/react-maplibre";

export default function LayerSettings(props) {
    const dataContext = useContext(DataContext);
    const mapHook = useMap({ mapId: "map_1" });
    const [buildingVisibility, setBuildingVisibility] = React.useState(false);

    function toogleBuildingsVisibility() {
        const newVisibility =
            buildingVisibility === "visible" ? "none" : "visible";
        mapHook.map.setLayoutProperty(
            "building-top",
            "visibility",
            newVisibility,
        );
        setBuildingVisibility(newVisibility);
    }

    const label = { inputProps: { "aria-label": "Fläche Fill zeigen" } };

    useEffect(() => {
        const layer = mapHook.map?.getLayer("building-top");
        if (!layer) {
            return;
        }
        setBuildingVisibility(
            mapHook.map.getLayoutProperty("building-top", "visibility"),
        );
    }, [mapHook.map]);

    useEffect(() => {
        const layer = mapHook.map?.getLayer("building-top");
        if (!layer) {
            return;
        }
        if (dataContext.showHDWms) {
            mapHook.map
                ?.getLayer("building-top")
                .setLayoutProperty("visibility", "none");
            setBuildingVisibility("none");
        }
    
    }, [mapHook.map, dataContext.showHDWms]);

    return (
        <>
            <LayerSettingsContainer
                extended={props.extended}
                setHeaderExtended={props.setHeaderExtended}
            >
                <Grid
                    container
                    alignItems="center"
                    sx={{ paddingLeft: "25px", paddingRight: "10px" }}
                >
                    {/* Flik layer Visibility */}
                    <Grid size={9}>
                        <Typography variant="body1">FLIK Fläche</Typography>
                    </Grid>
                    <Grid size={3}>
                        <IconButton
                            variant="contained"
                            color="secondary"
                            onClick={() => {
                                dataContext.setFlikDataHidden(
                                    !dataContext.flikDataHidden,
                                );
                            }}
                        >
                            {dataContext.flikDataHidden ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>

                    {/* Flik layer fill */}
                    {!dataContext.flikDataHidden && (
                        <>
                            <Grid size={9} alignContent={"center"}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginLeft: "10px" }}
                                >
                                    Füllung der Fläche
                                </Typography>
                            </Grid>
                            <Grid size={3}>
                                <Switch
                                    color="secondary"
                                    {...label}
                                    checked={dataContext.showFlikDataFill}
                                    onChange={() =>
                                        dataContext.setShowFlikDataFill(
                                            !dataContext.showFlikDataFill,
                                        )
                                    }
                                />
                            </Grid>
                        </>
                    )}

                    {/* Flik layer transparency */}
                    {!dataContext.flikDataHidden &&
                        dataContext.showFlikDataFill && (
                            <>
                                <Grid size={6} alignContent={"center"}>
                                    <Typography
                                        variant="body2"
                                        sx={{ marginLeft: "10px" }}
                                    >
                                        Deckkraft
                                    </Typography>
                                </Grid>
                                <Grid size={6}>
                                    <Slider
                                        aria-label="opacity"
                                        color="secondary"
                                        value={
                                            dataContext.flikDataOpacity ?? 0.4
                                        }
                                        min={0}
                                        max={1}
                                        step={0.1}
                                        valueLabelDisplay="auto"
                                        onChange={(ev, val) =>
                                            dataContext.setFlikDataOpacity(val)
                                        }
                                    />
                                </Grid>
                            </>
                        )}

                    {/* ProtectedArea layer Visibility */}
                    <Divider
                        sx={{
                            border: "1px inset rgb(55,55,55)",
                            borderRadius: 1,
                            width: "90%",
                        }}
                    />
                    <Grid size={9}>
                        <Typography variant="body1">Schutzgebiete</Typography>
                    </Grid>
                    <Grid size={3} alignContent={"center"}>
                        <IconButton
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                dataContext.setProtectedAreaHidden(
                                    !dataContext.protectedAreaHidden,
                                );
                            }}
                            sx={props.sx}
                        >
                            {dataContext.protectedAreaHidden ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>

                    {/* ProtectedAreas transparency */}
                    {!dataContext.protectedAreaHidden && (
                        <>
                            <Grid size={6} alignContent={"center"}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginLeft: "10px" }}
                                >
                                    Deckkraft
                                </Typography>
                            </Grid>
                            <Grid size={6}>
                                <Slider
                                    aria-label="opacity"
                                    color="secondary"
                                    value={
                                        dataContext.protecteAreasOpacity ?? 0.6
                                    }
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    valueLabelDisplay="auto"
                                    onChange={(ev, val) =>
                                        dataContext.setProtecteAreasOpacity(val)
                                    }
                                />
                            </Grid>
                            <Grid item size={10} alignContent={"center"}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginLeft: "10px" }}
                                >
                                    Beschrifftung:
                                </Typography>
                            </Grid>
                            <Grid item size={2}>
                                <Checkbox
                                    color="secondary"
                                    checked={dataContext.protecteAreasLabels}
                                    onChange={(ev) =>
                                        dataContext.setProtecteAreasLabels(
                                            ev.target.checked,
                                        )
                                    }
                                />
                            </Grid>
                        </>
                    )}

                    {/* Glöz2 layer Visibility */}
                    <Divider
                        sx={{
                            border: "1px inset rgb(55,55,55)",
                            borderRadius: 1,
                            width: "90%",
                        }}
                    />
                    <Grid item size={9}>
                        <Typography variant="body1">
                            Organische Böden
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <IconButton
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                dataContext.setGLöZ2AreasHidden(
                                    !dataContext.GLöZ2AreasHidden,
                                );
                            }}
                            sx={props.sx}
                        >
                            {dataContext.GLöZ2AreasHidden ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>

                    {/* ProtectedAreas transparency */}
                    {!dataContext.GLöZ2AreasHidden && (
                        <>
                            <Grid item size={6} alignContent={"center"}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginLeft: "10px" }}
                                >
                                    Deckkraft
                                </Typography>
                            </Grid>
                            <Grid item size={6}>
                                <Slider
                                    aria-label="opacity"
                                    color="secondary"
                                    value={dataContext.GLöZ2AreasOpacity ?? 0.6}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    valueLabelDisplay="auto"
                                    onChange={(ev, val) =>
                                        dataContext.SetGLöZ2AreasOpacity(val)
                                    }
                                />
                            </Grid>                            
                        </>
                    )}

                    {/* NUT2 layer Visibility */}
                    <Divider
                        sx={{
                            border: "1px inset rgb(55,55,55)",
                            borderRadius: 1,
                            width: "90%",
                        }}
                    />
                    <Grid item size={9}>
                        <Typography variant="body1">NUT2-Gebiete</Typography>
                    </Grid>
                    <Grid size={3}>
                        <IconButton
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                dataContext.setNUT2Hidden(
                                    !dataContext.NUT2Hidden,
                                );
                            }}
                            sx={props.sx}
                        >
                            {dataContext.NUT2Hidden ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>

                    {/* ProtectedAreas transparency */}
                    {!dataContext.NUT2Hidden && (
                        <>
                            <Grid item size={6} alignContent={"center"}>
                                <Typography
                                    variant="body2"
                                    sx={{ marginLeft: "10px" }}
                                >
                                    Deckkraft
                                </Typography>
                            </Grid>
                            <Grid item size={6}>
                                <Slider
                                    aria-label="opacity"
                                    color="secondary"
                                    value={dataContext.NUT2Opacity ?? 0.6}
                                    min={0}
                                    max={1}
                                    step={0.1}
                                    valueLabelDisplay="auto"
                                    onChange={(ev, val) =>
                                        dataContext.setNUT2Opacity(val)
                                    }
                                />
                            </Grid>
                        </>
                    )}

                    {/* OSM Buildings  layer Visibility */}
                    <Divider
                        sx={{
                            border: "1px inset rgb(55,55,55)",
                            borderRadius: 1,
                            width: "90%",
                        }}
                    />

                    <Grid size={9}>
                        <Typography variant="body1">Gebäude</Typography>
                    </Grid>
                    <Grid size={3} alignContent={"center"}>
                        <IconButton
                            color="secondary"
                            variant="contained"
                            onClick={() => toogleBuildingsVisibility()}
                            sx={props.sx}
                        >
                            {buildingVisibility === "none" ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>

                    {/* HD Staellite layer Visibility */}
                    <Divider
                        sx={{
                            border: "1px inset rgb(55,55,55)",
                            borderRadius: 1,
                            width: "90%",
                        }}
                    />

                    <Grid size={9}>
                        <Typography variant="body1">
                            HD Satellitenbilder
                        </Typography>
                    </Grid>
                    <Grid size={3}>
                        <IconButton
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                dataContext.setShowHDWms(
                                    !dataContext.showHDWms,
                                );
                            }}
                            sx={props.sx}
                        >
                            {!dataContext.showHDWms ? (
                                <VisibilityOffIcon />
                            ) : (
                                <VisibilityIcon />
                            )}
                        </IconButton>
                    </Grid>
                </Grid>
            </LayerSettingsContainer>
        </>
    );
}
